class GoogleTagManagerService {
  eventPageView(path) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'Pageview',
      pagePath: path,
      page_title: path,
    });
  }
}
const googleTagManagerService = new GoogleTagManagerService();
export default googleTagManagerService;
